import {List} from 'immutable';
import {of, throwError} from 'rxjs';

import PlansEntity from 'web-app/react/entities/plans/index';
import * as ManagePlanActions from 'web-app/react/plans/manage-plan/actions';
import {combineEpics} from 'web-app/util/redux-observable';
import * as Selectors from 'web-app/react/profile/child-profile/plans-and-invoices/selectors';
import * as PlansSelectors from 'web-app/react/entities/plans/selectors';
import {getOnEditPlanOptions} from 'web-app/react/profile/child-profile/plans-and-invoices/use-plans-functions';

import {openEditPlanModal, openEditPlanModalFailed, openEditPlanModalSuccess} from './actions';

const fetchEditPlanModalDataEpic = action$ =>
    action$.ofType(openEditPlanModal.type).mergeMap(({payload}) => {
        return PlansEntity.observables.fetchAll?.({id: payload.childId}).mergeMap(successActions => {
            return [
                ...successActions,
                openEditPlanModalSuccess.action(
                    payload.siteSetId,
                    payload.childId,
                    payload.childLocalStartDate,
                    payload.planId,
                ),
            ];
        });
    });

const openEditPlanModalEpic = (action$, state$) =>
    action$
        .ofType(openEditPlanModalSuccess.type)
        .mergeMap(({payload}) => {
            const plans = Selectors.plans(state$.value, {referenceId: payload.childId});

            const plan = plans.find(plan => plan.id === payload.planId);

            if (!plan) {
                return throwError('Plan not found');
            }

            const openEditPlanOptions = getOnEditPlanOptions(plan, plans, payload.childLocalStartDate);

            if (!openEditPlanOptions) {
                return throwError('Plan not found');
            }

            const {isLastPlan, validOnMustBeAfter, validOnMustBeBefore, validToMustBeAfter, validToMustBeBefore} =
                openEditPlanOptions;

            const planUsedSessions =
                PlansSelectors.makeGetSessionsById()(state$.value, {id: payload.planId}) ?? List([]);
            const planUsedProducts =
                PlansSelectors.makeGetProductsById()(state$.value, {id: payload.planId}) ?? List([]);

            return of(
                ManagePlanActions.showEditPlan.action({
                    institutionId: payload.siteSetId,
                    childId: payload.childId,
                    editPlan: plan,
                    planUsedSessions,
                    planUsedProducts,
                    canEditValidOn: true,
                    canEditValidTo: isLastPlan,
                    validOnMustBeAfter,
                    validOnMustBeBefore,
                    validToMustBeAfter, // Not allowed by backend yet, so the validTo field is disabled
                    validToMustBeBefore, // Not allowed by backend yet, so the validTo field is disabled
                }),
            );
        })
        .catch(error => of(openEditPlanModalFailed.action(error)));

export default combineEpics(fetchEditPlanModalDataEpic, openEditPlanModalEpic);
